/**
 * Use the function for validation logic.
 * Keep the regex only for legacy/direct match scenarios.
 */
export const UrlRegEx = /^https?:\/\/([\w-]+(\.[\w-]+)+(:\d{1,5})?)?([/?#]\S*)?$/i;
export const HostnameRegEx = /^[\w-]+(\.[\w-]+)+$/;

const parseUrl = (value) => {
    if (typeof URL.parse === 'function') {
        return URL.parse(value);
    }

    try {
        return new URL(value);
    } catch (error) {
        return null;
    }
};

export const normalizeWebsiteUrl = (websiteUrl = '') => {
    if (!websiteUrl || typeof websiteUrl !== 'string') {
        return '';
    }

    const trimmedUrl = websiteUrl.trim();
    if (!trimmedUrl) {
        return '';
    }

    // Follow GCM design: when a scheme is omitted, default to http instead of https.
    // https://confluence.garmin.com/display/DI/Group+setting+validation+logic
    const parsedUrl = parseUrl(trimmedUrl) || parseUrl(`http://${trimmedUrl}`);
    if (!parsedUrl) {
        return `http://${trimmedUrl}`;
    }

    const normalizedProtocol = (parsedUrl.protocol || '').toLowerCase();
    if (!['http:', 'https:'].includes(normalizedProtocol)) {
        parsedUrl.protocol = 'http:';
    }

    return parsedUrl.toString();
};

/**
 * @param {string} websiteUrl
 * @returns {boolean}
 */
export const isWebsiteUrlValid = (websiteUrl = '') => {
    if (!websiteUrl || typeof websiteUrl !== 'string' || websiteUrl.trim().length === 0) {
        return true;
    }

    const normalizedUrl = websiteUrl.trim();
    const hasDotSeparatedHostname = (hostname = '') => HostnameRegEx.test(hostname);

    if (typeof URL.parse === 'function') {
        const parsedUrl = URL.parse(normalizedUrl);
        return (
            !!parsedUrl &&
            ['http:', 'https:'].includes(parsedUrl.protocol) &&
            hasDotSeparatedHostname(parsedUrl.hostname)
        );
    }

    try {
        const parsedUrl = new URL(normalizedUrl);
        return ['http:', 'https:'].includes(parsedUrl.protocol) && hasDotSeparatedHostname(parsedUrl.hostname);
    } catch (error) {
        return false;
    }
};
